/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function Locations() {
  return (
    <CrudList
      title="Endereços (Locations)"
      endpoint="/api/core/locations/"
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'warehouse', header: 'Armazém', render: (r:any) => r.warehouse?.code ?? r.warehouse_code ?? '—' },
        { key: 'kind', header: 'Tipo' },
        { key: 'storage_class', header: 'Classe' },
        { key: 'is_active', header: 'Ativo' },
      ]}
    />
  )
}
